export const jobStatuses = [
    { name: 'Saved', value: 'Saved' },
    { name: 'Applied', value: 'Applied' },
    { name: 'Interviewed', value: 'Interviewed' },
    { name: 'Offer', value: 'Offer' },
    { name: 'Rejected', value: 'Rejected' }
  ];